import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { AuthFacade, ResourcesService } from '@mitsubishi/core';
import { DatasheetFacade } from '@mitsubishi/project/data-access';

import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-list-wrapper',
  templateUrl: './list-wrapper.component.html',
  styleUrls: ['./list-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListWrapperComponent extends FieldWrapper implements OnInit {
  readonly #resourcesService = inject(ResourcesService);
  readonly #datasheetFacade = inject(DatasheetFacade);

  canDebug = inject(AuthFacade).canDebug;

  selectedRow$ = this.#datasheetFacade.selectedRow$;
  isEditing$ = this.#datasheetFacade.isEditing$;

  isFirst = false;
  areAllFieldsHidden = false;

  ngOnInit() {
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
    this.areAllFieldsHidden = this.field.fieldGroup
      ? this.field.fieldGroup.every(field => field.props?.hidden === true)
      : true;
  }

  setSelectedRow(key?: any) {
    this.#datasheetFacade.setSelectedRow(key);
  }

  getRowLabel(field_props: FormlyFieldConfig['props']): string {
    return this.#resourcesService.getTextResourceWithPrefixSuffix({
      resourceId: field_props?.label,
      prefixResourceId: field_props?.prefixResourceId,
      suffixResourceId: field_props?.suffixResourceId,
    });
  }
}
